// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__RW9s7","inputWrap":"Table_inputWrap__kFeGV","col":"Table_col__3UnBQ","bmiTooltip":"Table_bmiTooltip__1dXDy"};